import React from 'react'
import ArticleBodyQuote from '../components/ArticleBodyQuote/ArticleBodyQuote'

const getText = node => [node.data, ...(node.children || []).map(getText)].join(' ')

export function transformArticleBodyContent (node, index) {
  if (node.name === 'blockquote' || (node.attribs && node.attribs.class === 'blockquote')) {
    return (
      <ArticleBodyQuote children={getText(node)} key={index} />
    )
  }
  if (node.name === 'p') {
    node.name = 'div'
  }
}



// WEBPACK FOOTER //
// ./client/utils/html.js